/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetPartQueryResponse, GetPartPathParams, GetPart400, GetPart401, GetPart403, GetPart404, GetPart409, GetPart500 } from "../../types/equipmentController/GetPart.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetPartUrl(organizationId: GetPartPathParams["organizationId"], partId: GetPartPathParams["partId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/equipment/parts/${partId}` as const }
  return res
}

/**
 * @summary Get part detail
 * {@link /api/organizations/:organizationId/equipment/parts/:partId}
 */
export async function getPart(organizationId: GetPartPathParams["organizationId"], partId: GetPartPathParams["partId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetPartQueryResponse, ResponseErrorConfig<GetPart400 | GetPart401 | GetPart403 | GetPart404 | GetPart409 | GetPart500>, unknown>({ method : "GET", url : getGetPartUrl(organizationId, partId).url.toString(), ... requestConfig })
  return res.data
}